module.exports = __webpack_public_path__ + "static/tasks_04@2x-0a82e53d420407e2d651a46cccaa67cf.png";